// extracted by mini-css-extract-plugin
module.exports = {"textblock":"Textblock_textblock__c2aSt","centered":"Textblock_centered__RpLix","dropcap":"Textblock_dropcap__nVJlv"};